<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Add Menu Item</span>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-0">Add Menu Item</h2>
        <!-- <button class="btn btn-primary" (click)="goToBulkUploadPage()">Bulk Upload</button> -->
    </div>

    <!-- form start -->
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">

        <div formArrayName="newMenuGroups">
            <div class="mb-md-4 position-relative" *ngFor="let item of newMenuGroups().controls; let i=index" [formGroupName]="i">


                <!-- ROOT CAUSE FIX: Removed ngb-panel + ng-template ngbPanelContent (breaks inside formArrayName + *ngFor) -->
                <ngb-accordion [activeIds]="activeIds" class="form_accordion">
                    <!-- Food Details Section -->
                    <div class="mb-4 mb-md-5">
                        <h5 class="mb-3 mb-md-4 font-weight-medium">Food Details</h5>
                        <div class="row row-gap-4">
                                <div class="d-flex flex-column row-gap-1 col-4">
                                    <div class="form-group floating_form_field mb-0 w-100">
                                        <input type="text" formControlName="FoodName" id="FoodName" class="form-control"
                                            placeholder="Food Name" [(ngModel)]=foodcourt.FoodName>
                                        <label>Food Name</label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div *ngIf="newMenuGroups().controls[i].get('FoodName').invalid && newMenuGroups().controls[i].get('FoodName').touched"
                                            class="small text-danger">
                                            <div *ngIf="newMenuGroups().controls[i].get('FoodName').errors?.required">Food
                                                Name
                                                is required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex flex-column row-gap-1 col-4">
                                    <div class="form-group floating_form_field mb-0 w-100">
                                        <select class="form-control" formControlName="FoodType" [(ngModel)]="foodcourt.FoodType">
                                            <option value="">Select Type</option>
                                            <option value="{{typemenu.id}}" *ngFor="let typemenu of menuType">
                                                {{typemenu.name}}
                                            </option>
                                        </select>
                                        <label>Select Type</label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div *ngIf="newMenuGroups().controls[i].get('FoodType').invalid && newMenuGroups().controls[i].get('FoodType').touched"
                                            class="small text-danger">
                                            <div *ngIf="newMenuGroups().controls[i].get('FoodType').errors?.required">Food Type
                                                is required</div>
                                        </div>
                                    </div>
                                </div>
            
                                <div class="d-flex flex-column row-gap-1 col-4">
                                    <div class="form-group floating_form_field mb-0 w-100">
                                        <select class="form-control" formControlName="FoodCuisine"
                                            [(ngModel)]="foodcourt.FoodCuisine">
                                            <option value="">Select Type</option>
                                            <option value="{{menucuissien.id}}" *ngFor="let menucuissien of menuCuissine">
                                                {{menucuissien.name}}
                                            </option>
                                        </select>
                                        <label>Select Type</label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div *ngIf="newMenuGroups().controls[i].get('FoodCuisine').invalid && newMenuGroups().controls[i].get('FoodCuisine').touched"
                                            class="small text-danger">
                                            <div *ngIf="newMenuGroups().controls[i].get('FoodCuisine').errors?.required">Cuissine
                                                is required</div>
                                        </div>
                                    </div>
                                </div>
            
                                <div class="d-flex flex-column row-gap-1 col-4">
                                    <div class="form-group floating_form_field mb-0 w-100">
                                        <input type="text" formControlName="FoodPrice" id="FoodPrice"
                                            class="form-control" placeholder="Food Price"
                                            [(ngModel)]=foodcourt.FoodPrice>
                                        <label>Price</label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div *ngIf="newMenuGroups().controls[i].get('FoodPrice').invalid && newMenuGroups().controls[i].get('FoodPrice').touched"
                                            class="small text-danger">
                                            <div
                                                *ngIf="newMenuGroups().controls[i].get('FoodPrice').errors?.required">
                                                Food
                                                Price
                                                is required</div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="d-flex flex-column row-gap-1 col-4">
                                    <div class="form-group floating_form_field mb-0 w-100">
                                        <select class="form-control" formControlName="IsAvailable"
                                            [(ngModel)]="foodcourt.IsAvailable">
                                            <option value="">Select Availability</option>
                                            <option value="{{menuavailability.id}}"
                                                *ngFor="let menuavailability of menuAvability">
                                                {{menuavailability.name}}
                                            </option>
                                        </select>
                                        <label>Select Availability</label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div *ngIf="newMenuGroups().controls[i].get('IsAvailable').invalid && newMenuGroups().controls[i].get('IsAvailable').touched"
                                            class="small text-danger">
                                            <div *ngIf="newMenuGroups().controls[i].get('IsAvailable').errors?.required">
                                                Food Availability
                                                is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <!-- Description Section -->
                    <div class="mb-4 mb-md-5 border-top border-light pt-4 pt-md-5">
                        <h5 class="mb-3 mb-md-4 font-weight-medium">Description</h5>
                        <div class="row row-gap-4">
                                <div class="d-flex flex-column row-gap-1 col-12 col-md-8">
                                    <div class="form-group floating_form_field mb-0 w-100">
                                        <textarea formControlName="FoodDescription" id="FoodDescription" class="form-control"
                                            placeholder="Coupon Details" [(ngModel)]=foodcourt.FoodDescription cols="30"
                                            rows="10"></textarea>
                                        <label>
                                            Description
                                        </label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div *ngIf="newMenuGroups().controls[i].get('FoodDescription').invalid && newMenuGroups().controls[i].get('FoodDescription').touched"
                                            class="small text-danger">
                                            <div *ngIf="newMenuGroups().controls[i].get('FoodDescription').errors?.required">
                                                Description is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <!-- Image Section -->
                    <div class="mb-4 mb-md-5 border-top border-light pt-4 pt-md-5">
                        <h5 class="mb-3 mb-md-4 font-weight-medium">Image</h5>
                        <div class="row row-gap-4">
                                <div class="col-12 col-md-4 d-flex flex-column row-gap-1">
                                    <div class="d-flex align-items-center justify-content-between upload_field"
                                        (click)="uploadImages.click()">
                                        <span class="text-truncate mr-3">{{imageName ? imageName : 'Upload Image'}}</span>
                                        <svg-icon src="../../../assets/images/icons/upload.svg"></svg-icon>
                                    </div>
                                    <input onclick="this.value = null" formControlName="VendorPhotos" id="VendorPhotos" type="file"
                                        class="d-none" accept=".png, .jpg, .jpeg" (change)="onFileChange($event)" #uploadImages>
                                </div>
            
                                <div class="col-12" *ngIf="images.length">
                                    <div class="row row-gap-3">
                                        <div class="col-12 col-md-6 col-lg-4 col-xl-3"
                                            *ngFor='let image of images; let i = index;'>
                                            <div class="uploaded_images">
                                                <img [src]="image.imgBase64">
                                                <span class="remove_icon" (click)="removeImage(i)">
                                                    <svg-icon src="../../../assets/images/icons/close.svg"></svg-icon>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </ngb-accordion>
            </div>
        </div>
        <div
            class="py-3 py-md-4 border-top border-light mt-3 mt-md-4 d-flex align-items-center justify-content-end column-gap-3">
            <button class="btn btn-clear text-muted" type="button" (click)="goToListPage()">Cancel</button>
            <button class="btn btn-primary" type="submit">Submit</button>
        </div>
    </form>
    <!-- form end -->
</div>